<template>
	<section class="ctn">
		<header class="header left">
			<router-link class="paper-action" :to="{ path: `/providers`}"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
		</header>
		<main class="provider-details">
			<section class="info">
				<heim-card>
					<main>
						<div class="row">
							<h1>{{ provider.name }}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
				<heim-card class="monitoring">
					<main>
            <div class="row" v-for="server in servers" :key="`providerProject-${server.id}`">
							<div class="details-row">
								<span><router-link :to="{ path: `/servers/${server.id}/details` }">{{ server.name }}</router-link></span>
								<span class="badge">{{ server.ip }}</span>
							</div>
						</div>
					</main>
				</heim-card>
			</section>
		</main>
	</section>
</template>


<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimCard from "@/components/layout/card/heim-card.vue";
import { mapState } from "vuex";

export default {
  name: "ProvidersDetails",
  components: {
    HeimIcon,
    HeimCard
  },
  data() {
    return {
      options: {
        responsive: true,
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                // round: 'day'
                tooltipFormat: "ll HH:mm"
              },
              scaleLabel: {
                display: true,
                labelString: "Time"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "value"
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getProvider", id);
    this.$store.dispatch("getServerInProvider", id);

    this.$watch(
      vm => vm.provider,
      val => {
        this.$store.dispatch("setTitle", `Provider - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({
      provider: state => state.providersState.provider,
      servers: state => state.serversState.serverProvider
    })
  },
  methods: {}
};
</script>

<style scoped>
.provider-details,
.details-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}
.details-row {
  width: 100%;
}

.details-row .badge {
  background-color: var(--heim-grey-color);
}

.provider-details > .paper-card,
.provider-details > .info {
  width: 100%;
  margin-right: 0;
}

.provider-details .stats,
.provider-details .monitoring {
  margin-bottom: 1em;
}

.info {
  display: flex;
  flex-direction: column;
}

.disabled {
  color: #8b969c;
}

.monitoring,
.site {
  margin-bottom: 1em;
}

.link {
  padding: 1em;
  border-bottom: 1px solid #eee;
}

.link:last-child {
  border: none;
}

.info .paper-card {
  border-radius: 3px 3px 0 0;
}

.paper-card.monitoring {
  border-radius: 0;
}
.details-row span:first-child {
  padding: 0.2rem 0;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .provider-details {
    flex-wrap: nowrap;
  }
  .provider-details > .paper-card,
  .provider-details > .info {
    width: 50%;
    margin-right: 1em;
    height: 100%;
  }
}
</style>
